import React from 'react';
import Intl from 'src/components/Intl';

const questionSelections = {
  hearAbout: {
    id: 'answers[3038][answers]',
    options: [
      {
        value: 'Email Outreach',
        content: 'Email Outreach'
      },
      {
        value: 'Facebook',
        content: 'Facebook'
      },
      {
        value: 'Friends and Family',
        content: 'Friends and Family'
      },
      {
        value: 'Instagram',
        content: 'Instagram'
      },
      {
        value: 'MLS',
        content: 'MLS'
      },
      {
        value: 'Online Search',
        content: 'Online Search'
      },
      {
        value: 'Print Publication',
        content: 'Print Publication'
      },
      {
        value: 'Realtor',
        content: 'Realtor'
      },
      {
        value: 'Signage/Walk- or Drive-by',
        content: 'Signage/Walk- or Drive-by'
      },
      {
        value: 'WeChat',
        content: 'WeChat'
      },
      {
        value: 'Other',
        content: 'Other'
      },
    ]
    
  },
  isRealtor: {
    id: 'agent',
    options: [
      {
        value: 'false',
        content: 'No'
      },
      {
        value: 'true',
        content: 'Yes'
      }
    ]
  },
  isWorkingWithRealtor: {
    id: 'answers[8454][answers]',
    options: [
      {
        value: 'No',
        content: 'No'
      },
      {
        value: 'Yes',
        content: 'Yes'
      }
    ]
  },
  isOrWorkingWithRealtor: {
    id: 'isOrWorkingWithRealtor',
    options: [
      {
        value: 'Yes, I am realtor',
        content: 'Yes, I am realtor'
      },
      {
        value: 'No, I am not a realtor',
        content: 'No, I am not a realtor'
      },
      {
        value: 'Yes, I am working with a realtor',
        content: 'Yes, I am working with a realtor'
      },
      {
        value: 'No, I am not working with a realtor',
        content: 'No, I am not working with a realtor'
      }
    ]
  },
  isHomeownerAtTAB: {
    id: 'isHomeownerAtTAB',
    options: [
      {
        value: 'No, none of the above',
        content: 'No, none of the above'
      },
      {
        value: 'Yes, I am a retailer',
        content: 'Yes, I am a retailer'
      },
      {
        value: 'Yes, I am a rental tenant',
        content: 'Yes, I am a rental tenant'
      },
      {
        value: 'Yes, I am a current homeowner',
        content: 'Yes, I am a current homeowner'
      }
    ]
  },
  isTABRetailer: {
    id: 'answers[8553][answers]',
    options: [
      {
        value: 'No',
        content: 'No'
      },
      {
        value: 'Yes',
        content: 'Yes'
      }
    ]
  },
  isTABTenant: {
    id: 'answers[8557][answers]',
    options: [
      {
        value: 'No',
        content: 'No'
      },
      {
        value: 'Yes',
        content: 'Yes'
      }
    ]
  },
  isTABHomeowner: {
    id: 'answers[9501][answers]',
    options: [
      {
        value: 'No',
        content: 'No'
      },
      {
        value: 'Yes',
        content: 'Yes'
      }
    ]
  },
  reasonForPurchase: {
    id: 'reasonForPurchase',
    options: [
      {
        value: 'Principal Residence',
        content: 'Principal Residence'
      },
      {
        value: 'Secondary Residence',
        content: 'Secondary Residence'
      },
      {
        value: 'For A Family Member',
        content: 'For A Family Member'
      },
      {
        value: 'Investment',
        content: 'Investment'
      }
    ]
  }
  ,
  numberOfHomesRequested: {
    id: 'numberOfHomesRequested',
    options: [
      {
        value: '1',
        content: '1'
      },
      {
        value: '2',
        content: '2'
      },
      {
        value: '3+',
        content: '3+'
      }
    ]
  },
  numberOfBuyers: {
    id: 'numberOfBuyers',
    options: [
      {
        value: '1',
        content: '(1) One - only me'
      },
      {
        value: '2',
        content: '(2) Two - myself and one other'
      },
      {
        value: '3',
        content: '(3) Three - myself and two others'
      },
      {
        value: '4',
        content: '(4) Four - myself and three others'
      }
    ]
  }
  ,
  colourScheme: {
    id: 'colourScheme',
    options: [
      {
        value: 'Timeless White',
        content: 'Timeless White'
      },
      {
        value: 'Classic Grey',
        content: 'Classic Grey'
      }
    ]
  },
  homeOptionOneBeds: {
    id: 'homeOptionOneBeds',
    options: [
      {
        value: 'Studio',
        content: 'Studio'
      },
      {
        value: '1 BR',
        content: '1 BR'
      },
      {
        value: '1 BR + D',
        content: '1 BR + D'
      },
      {
        value: '2 BR',
        content: '2 BR'
      },
      {
        value: '2 BR + D',
        content: '2 BR + D'
      },
      {
        value: '3 BR',
        content: '3 BR'
      },
      {
        value: '3 BR + D',
        content: '3 BR + D'
      },
      {
        value: '4 BR ',
        content: '4 BR'
      }
    ]
  },
  isPermanentResident: {
    id: 'isPermanentResident',
    options: [
      {
        value: 'IS',
        content: 'Yes'
      },
      {
        value: 'IS NOT',
        content: 'No'
      }
    ]
  },
  isForeignEntity: {
    id: 'isForeignEntity',
    options: [
      {
        value: 'IS',
        content: 'Yes'
      },
      {
        value: 'IS NOT',
        content: 'No'
      }
    ]
  }
}

export default questionSelections;
